import { render } from "./TransferModal.vue?vue&type=template&id=bde0a89a&scoped=true"
import script from "./TransferModal.vue?vue&type=script&lang=js"
export * from "./TransferModal.vue?vue&type=script&lang=js"

import "./TransferModal.vue?vue&type=style&index=0&id=bde0a89a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bde0a89a"

export default script